// extracted by css-extract-rspack-plugin
export default {"cls1":"AuthorsCard-cls1_ybL","cls2":"AuthorsCard-cls2_v9d AuthorsCard-cls1_ybL"};